import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

import { SocialMedia } from '../../model/socialmedia';
import { decodeFiwareString } from '../../shared/replacer-util';

export interface SocialMediaState extends EntityState<SocialMedia> {
  hasMore: boolean;
  page: number;
}

const initialState: SocialMediaState = {
  hasMore: true,
  page: 1
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'SocialMedia' })
export class SocialMediaStore extends EntityStore<SocialMediaState> {
  constructor() {
    super(initialState);
  }

  updatePage(page: { hasMore: boolean; page: number }) {
    this.update(page);
  }

  akitaPreAddEntity(entity: SocialMedia) {
    return decodeEntity(entity);
  }

  akitaPreUpdateEntity(_: SocialMedia, newEntity: SocialMedia) {
    return decodeEntity(newEntity);
  }
}

function decodeEntity(entity: SocialMedia) {
  entity.message = decodeFiwareString(entity.message);
  entity.snippet = decodeFiwareString(entity.snippet);
  entity.originalUrl = decodeFiwareString(entity.originalUrl);

  return entity;
}
